export const LoginStates = {
  onboarding: "onboarding",
  welcomeLogin: "welcomeLogin",
  otpVerification: "otpVerification",
};

export const LoginStateStatus = {
  ANONYMOUS_USER_LOGGING_IN: "ANONYMOUS_USER_LOGGING_IN",
  ANONYMOUS_USER_LOGGED_IN: "ANONYMOUS_USER_LOGGED_IN",
  SENDING_OTP: "SENDING_OTP",
  SENT_OTP: "SENT_OTP",
  SENDING_OTP_FAILED: "SENDING_OTP_FAILED",
  VALIDATING_OTP: "VALIDATING_OTP",
  VALIDATED_OTP_INVALID: "VALIDATED_OTP_INVALID",
  VALIDATED_OTP_VALID: "VALIDATED_OTP_VALID",
};
